import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import LiveGraph from './Components/LiveGraph';
import DeviceMap from './Components/DeviceMap';
import AdminDashboard from './Components/AdminDashboard';
import SeismicGraphViewer from './Components/SeismicGraphViewer';  

import './App.css'

const AppContent = () => {
    const location = useLocation();
    const isFullWidthPage = location.pathname === '/' || location.pathname === '/about';

    return (
        <>
            <Header />
            <main
                style={isFullWidthPage
                    ? {
                        padding: 0,
                        margin: 0,
                        maxWidth: 'none',
                        borderRadius: 0,
                        boxShadow: 'none',
                        background: 'transparent',
                    }
                    : { padding: '0px' }}
            >
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/live-graph" element={<LiveGraph />} />
                    <Route path="/device-map" element={<DeviceMap />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/seismic-graph-viewer/*" element={<SeismicGraphViewer />} />
                 </Routes>
            </main>
            <Footer />
        </>
    );
};

const App = () => {
    return (
        <Router>
            <AppContent />
        </Router>
    );
};

export default App;
